import React from 'react'

import Layout from '../components/Layout'

/**
 * Sections of the page
 */
import {
  Intro,
  Context,
  Approach,
  VisionMission,
  Mandate,
  NextSteps,
  Words
} from '../sections/home'

const IndexPage = () => (
  <Layout>
    <Intro />
    <Context />
    <Approach />
    <VisionMission />
    <Mandate />
	<NextSteps />
    <Words />
  </Layout>
)

export default IndexPage
